import React from 'react';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { arrayOf, string } from 'prop-types';
import classNames from 'classnames';
import { propTypes } from '../../util/types';

import ReviewCard from '../ReviewCard/ReviewCard';
import css from './Reviews.module.css';

/**
 * Review list used by the listing page (via StoreReviews).
 *
 * Each row is the shared ReviewCard - the same component the Store Profile reviews tab
 * renders - so the two surfaces are identical by construction. This file previously
 * carried its own copy of the card markup plus a parallel stylesheet, and the two had
 * drifted apart (different type scale, outlined rather than filled verification badges,
 * a different "Rented:" row). Only the list chrome lives here now.
 *
 * `reviewsByUsers` is the listing page's per-reviewer verification data
 * (ListingPage.duck.js); it is matched to each review's author here and handed to the
 * card, which falls back to its Store Profile default when a reviewer has no entry.
 */
const ReviewsComponent = props => {
  const { className, rootClassName, reviews, reviewsByUsers, intl } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <ul className={classes}>
      {reviews.map(r => (
        <li key={`Review_${r.id.uuid}`} className={css.reviewItem}>
          <ReviewCard
            review={r}
            intl={intl}
            reviewerVerificationData={
              reviewsByUsers?.find(user => user.id === r.author.id.uuid) || null
            }
          />
        </li>
      ))}
    </ul>
  );
};

ReviewsComponent.defaultProps = {
  className: null,
  rootClassName: null,
  reviews: [],
};

ReviewsComponent.propTypes = {
  className: string,
  rootClassName: string,
  reviews: arrayOf(propTypes.review),

  // from injectIntl
  intl: intlShape.isRequired,
};

const Reviews = injectIntl(ReviewsComponent);

export default Reviews;
